module.exports = __webpack_public_path__ + "static/media/ProfileStep4.d54502b7.svg";